import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { brandNeutralColors } from '@anyroad/theme';

const Style = styled.h1`
  &.CheckoutHeader {
    color: ${brandNeutralColors.text.primary};
    font-size: 28px;
    font-weight: 600;
    line-height: 20px;
    margin: 0 0 24px 0;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = () => {
  return (
    <HeaderContainer>
      <Style className="CheckoutHeader">
        <FormattedMessage
          defaultMessage="Review and Book"
          description="Main heading for the checkout page where users review their booking details before completing purchase"
        />
      </Style>
    </HeaderContainer>
  );
};
